export interface IGeneralState {}

export const GENERAL_SET = 'GENERAL_SET';

export interface IGeneralSetAction {
  isCompiled?: boolean;
}
